
export function tabInit() {
  buildTabs()
  clickTab()
}

function buildTabs() {
  let $tabs = false;
  let $tabs_header = false;
  $('.tab').each(function() {
    const $tab = $(this)
    const lasttab = !$tab.next('.tab').length
    const firsttab = !$tabs
    const tabname = $tab.attr('data-title')
    const tabicon = $tab.attr('data-icon')
    if(firsttab) {
      $tabs = $('<div class="tabs"></div>');
      $tabs_header = $('<div class="tabs__header scrollable-horizontally"></div>');
      $tabs.insertBefore($tab);
      $tab.addClass('active');
    }
    $tabs.append($tab)
    $tabs_header.append('<a class="' + (firsttab ? 'active initial' : '') + '" data-toggle="' + tabname + '" href="#">' + (tabicon ? '<i style="background-image:url(' + tabicon + ')"></i> ' : '' ) + tabname + '</a>')
    if(lasttab) {
      $tabs.prepend($tabs_header)
      $tabs_header = false;
      $tabs = false;
    }
  });
}

function clickTab() {
  $('body').on('click', '.tabs__header a', function(e){
    e.preventDefault();
    const $new = $(this);
    const $tabs = $(this).closest('.tabs');
    const tabname = $(this).attr('data-toggle')
    const prev_index = $('a', $tabs).index($('a', $tabs).filter($('.active', $tabs)))
    const new_index = $('a', $tabs).index($('a', $tabs).filter($new))
    const animclasses = "initial moveFromRight moveToRight moveFromLeft moveToLeft"
    $('.active', $tabs).removeClass(animclasses).addClass((new_index < prev_index ? "moveToLeft" : "moveToRight" ))
    $new.removeClass(animclasses).addClass((new_index < prev_index ? "moveFromRight" : "moveFromLeft" ))
    $('.active', $tabs).removeClass('active')
    $new.addClass('active')
    $('.tab[data-title="'+tabname+'"]', $tabs).addClass('active')
  })
}
